import type { ProductUrlType } from '@noths/polaris-dev-ts-types';

import type { SectionVisibleReturn } from 'src/redux/visibilityTracking';
import { PageType, ProductFieldObject } from 'src/types';
import { NAVIGATION_TILE_URL } from '../components/NavigationTile';

export const NAVIGATION_TILE_VISIBILITY_NAME = 'NavigationTile';

export type ClickEcommerce = {
  click: {
    actionField: {
      list: string;
    };
    products: [ProductFieldObject<PageType>];
  };
};

export interface ProductClick {
  event: 'product_clicks';
  event_category: 'Product listings';
  event_action: 'Product Click';
  event_label: 'null';
  /* the destination URL path of the product page */
  destination_URL: ProductUrlType;
  eventCallback?: VoidFunction;
  eventTimeout?: number;
  ecommerce: ClickEcommerce;
}

export interface NavigationTileClick {
  event: 'custom_event';
  event_category: 'Category tile';
  event_action: 'Click';
  event_label: 'Stocking fillers';
  destination_url: typeof NAVIGATION_TILE_URL;
  content_position: `${number}`;
  content_type: 'category tile';
  selected_position: `${number}`;
  item_id: 'stocking filler';
}

export interface NavigationTileImpression {
  event: 'custom_event';
  event_category: 'Category tile';
  event_action: 'Impression';
  event_label: 'Stocking fillers';
  destination_url: typeof NAVIGATION_TILE_URL;
  content_position: `${number}`;
  content_type: 'category tile';
  item_id: 'stocking filler';
}

export interface NavigationTileImpressionActionPayload {
  position: number;
}

export type NavigationTileImpressionActionReturn =
  SectionVisibleReturn<NavigationTileImpressionActionPayload>;
